import { Root } from '@radix-ui/react-alert-dialog';
import { PropsWithChildren, useEffect, useState } from 'react';

import { ModalContext } from '@shared/ui/components/Modal/ModalContext';

type DialogProps = PropsWithChildren<{
  open?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
}>;

export function Modal({ children, onClose, onOpen, open: openProp }: DialogProps) {
  const [open, setOpen] = useState(openProp ?? false);

  useEffect(() => {
    setOpen(openProp ?? false);
  }, [openProp]);

  useEffect(() => {
    if (open) {
      onOpen?.();
    } else {
      onClose?.();
    }
  }, [open]);

  return (
    <ModalContext.Provider value={{ open, setOpen }}>
      <Root open={open} onOpenChange={setOpen}>
        {children}
      </Root>
    </ModalContext.Provider>
  );
}
